"use client";

import { useState, useRef } from "react";
import VideoModal from "@/components/VideoModal/VideoModal";

import Avatar from "../images/happy-customers/reviewer-1.png";
import Picture from "../images/happy-customers/singapore-reviews-img-1-1.jpg";
import Review from "../images/happy-customers/google-review.svg";

import Avatar1 from "../images/happy-customers/reviewer-2.png";
import Picture1 from "../images/happy-customers/singapore-reviews-img-1-2.jpg";

import Avatar2 from "../images/happy-customers/s.png";
import Picture2 from "../images/happy-customers/singapore-reviews-img-1-3.jpg";

import Avatar3 from "../images/happy-customers/sri.png";
import Picture4 from "../images/happy-customers/singapore-reviews-img-1-5.jpg";

import Picture5 from "../images/happy-customers/singapore-video-review-2.jpg";
import Picture6 from "../images/happy-customers/singapore-video-review-1.jpg";

import "@/styles/common/customer-reviews.scss";
import "@/sections/common/happy-customers/happy-customers.scss";
import "@/styles/common/typo.scss";

import Button from "@/components/button/Button";
import Heading from "@/components/heading/heading";

import Image from "next/image";
import { Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

const REVIEWS1 = [
    {
        id: 1,
        name: "Mathews A",
        review: "I had a great experience travelling to singapore through dimaak tours. Good service. Subhash done a great job in coordination.",
        image: Avatar,
    },
    {
        id: 2,
        showImage: true,
        image: Picture,
    },
    {
        id: 3,
        name: "Jazz Entertainment",
        review: "Wow . Dimaark is one of the best tour package services . The team choosing Excellent hotels ...",
        image: Avatar1,
    },
    {
        id: 4,
        showImage: true,
        image: Picture1,
        thumbnail: Picture5,
        videoId: "N8VLEEA6s2w",
        videoTitle: "Maldives",
    },

    {
        id: 5,
        name: "Saravanan P",
        review: "It's very nice and enjoyed lot good arrangement and good guide especially anirudh presence kind cooperation with us.special thanks Anirudh and Candy.",
        image: Avatar2,
    },
]
const REVIEWS2 = [
    {
        id: 6,
        showImage: true,
        image: Picture2,
    },
    {
        id: 7,
        name: "Sri Ganesh Ram",
        review: "Thank you so much for the amazing trip. It is great experience with worry free and safety",
        image: Avatar3,
    },
    {
        id: 8,
        showImage: true,
        image: Picture2,
        thumbnail: Picture6,
        videoId: "gj52_sLp8I0",
        videoTitle: "Singapore",
    },
    {
        id: 9,
        showImage: true,
        image: Picture4,
    },
];

const HappyCustomers = () => {
    const [modalStates, setModalStates] = useState(REVIEWS1.map(() => false));
    const [modal2States, setModal2States] = useState(REVIEWS2.map(() => false));
    const swiperRef1 = useRef<any>(null);
    const swiperRef2 = useRef<any>(null);

    const handleEnter = () => {
        swiperRef1.current.swiper.autoplay.stop();
        swiperRef2.current.swiper.autoplay.stop();
    };

    const handleLeave = () => {
        swiperRef1.current.swiper.autoplay.start();
        swiperRef2.current.swiper.autoplay.start();
    };

    const openModal = (index: number, reviewsListNo: number) => {
        if (reviewsListNo === 1) {
            const newModalStates = [...modalStates];
            newModalStates[index] = true;
            setModalStates(newModalStates);
        } else {
            const newModalStates = [...modal2States];
            newModalStates[index] = true;
            setModal2States(newModalStates);
        }
    };

    const closeModal = (index: number, reviewsListNo: number) => {
        if (reviewsListNo === 1) {
            const newModalStates = [...modalStates];
            newModalStates[index] = false;
            setModalStates(newModalStates);
        } else {
            const newModalStates = [...modal2States];
            newModalStates[index] = false;
            setModal2States(newModalStates);
        }
    };

    return (
        <section className="happy-customers-section">
            <div className="container px-4 mx-auto flex flex-col gap-6 sm:gap-14">
                <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
                    <div className="happy-customers-block col-span-1 flex flex-col justify-center items-start gap-3 sm:gap-6 lg:col-span-1">
                        <small className="font-yesteryear font-extralight">
                            Our Customers Love
                        </small>
                        <Heading as="h2">Travel Experiences</Heading>
                        <p className="lead">
                        Discover what our valued customers have to say about their unforgettable experiences. Read genuine reviews and testimonials showcasing the joy and satisfaction of their journeys with us
                        </p>
                        <div className="button-review flex flex-wrap items-center gap-6">
                            <Button
                                onClick={() =>
                                    window.open(
                                        "https://bit.ly/dimaakreviews",
                                        "_blank"
                                    )
                                }
                                className="flex items-center"
                                variant="orange"
                            >
                                <span>View more Reviews</span>
                            </Button>
                            <Image loading="lazy"
                                src={Review}
                                alt="Review"
                                className="review"
                                
                            />
                        </div>
                    </div>
                    <div className="happy-customers-slider happy-customers-slider-vertical col-span-1 flex-col gap-4 lg:col-span-2 hidden lg:flex">
                        <div
                            className="grid-cols-1 gap-6 lg:grid-cols-2 grid"
                            onMouseEnter={handleEnter}
                            onMouseLeave={handleLeave}
                        >
                            <div className="happy-customers-slider-one happy-customers-slider col-span-1 flex flex-col gap-4 lg:col-span-1">
                                <Swiper
                                    ref={swiperRef1}
                                    slidesPerView={1.5}
                                    spaceBetween={30}
                                    centeredSlides={true}
                                    direction="vertical"
                                    speed={3000}
                                    modules={[Autoplay]}
                                    autoplay={{
                                        delay: 1,
                                        disableOnInteraction: false,
                                        waitForTransition: true,
                                        pauseOnMouseEnter: true,
                                    }}
                                    loop={true}
                                    className="swiper-container"
                                    autoHeight={true}
                                    height={400}
                                >
                                    {REVIEWS1?.map((review, index) => (
                                        <SwiperSlide
                                            key={review.id}
                                            className={`swiper-slide ${
                                                review.showImage
                                                    ? "with-image-h"
                                                    : "without-image-h"
                                            }`}
                                            style={{
                                                height: "100% !important",
                                                color: "red",
                                            }}
                                        >
                                            {review.showImage ? (
                                                <div className="with-image h-full">
                                                    {review.videoId ? (
                                                        <div
                                                            className="picture object-fill h-full"
                                                            onClick={() =>
                                                                openModal(
                                                                    index,
                                                                    1
                                                                )
                                                            }
                                                            style={{
                                                                cursor: "pointer",
                                                            }}
                                                        >
                                                            <Image
                                                                loading="lazy"
                                                                src={
                                                                    review.thumbnail
                                                                }
                                                                alt="Picture"
                                                                className="picture object-fill h-full"
                                                            />
                                                            <div
                                                                className="play-button"
                                                                style={{
                                                                    position:
                                                                        "absolute",
                                                                    top: "50%",
                                                                    left: "50%",
                                                                    transform:
                                                                        "translate(-50%, -50%)",
                                                                    cursor: "pointer",
                                                                }}
                                                            >
                                                                <svg
                                                                    width="61"
                                                                    height="61"
                                                                    viewBox="0 0 61 61"
                                                                    fill="none"
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                >
                                                                    <circle
                                                                        cx="30.5"
                                                                        cy="30.5"
                                                                        r="30.5"
                                                                        fill="#FFF3ED"
                                                                    />
                                                                    <path
                                                                        d="M42 30L24 40.3923L24 19.6077L42 30Z"
                                                                        fill="#FF4514"
                                                                    />
                                                                </svg>
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <Image
                                                            loading="lazy"
                                                            src={review.image}
                                                            alt="Picture"
                                                            className="picture object-fill h-full"
                                                        />
                                                    )}

                                                    <VideoModal
                                                        videoTitle={
                                                            review.videoTitle
                                                        }
                                                        videoId={review.videoId}
                                                        isOpen={
                                                            modalStates[index]
                                                        }
                                                        onClose={() => {
                                                            closeModal(
                                                                index,
                                                                1
                                                            );
                                                            swiperRef1.current.swiper.autoplay.start();
                                                            swiperRef2.current.swiper.autoplay.start();
                                                        }}
                                                    />
                                                </div>
                                            ) : (
                                                <div className="without-image p-4 xl:p-6 flex flex-col gap-3 h-full">
                                                    <p className="lead">
                                                        {review.review}
                                                    </p>
                                                    <div className="avatar flex items-center mt-auto gap-3">
                                                        <Image
                                                            loading="lazy"
                                                            src={review.image}
                                                            alt="Avatar"
                                                            className="avatar"
                                                        />
                                                        <span className="font-semibold">
                                                            {review.name}
                                                        </span>
                                                    </div>
                                                </div>
                                            )}
                                        </SwiperSlide>
                                    ))}
                                </Swiper>
                            </div>
                            <div className="happy-customers-slider-two happy-customers-slider col-span-1 flex flex-col gap-4 lg:col-span-1">
                                <Swiper
                                    ref={swiperRef2}
                                    slidesPerView={1.5}
                                    spaceBetween={30}
                                    centeredSlides={true}
                                    direction="vertical"
                                    speed={3000}
                                    modules={[Autoplay]}
                                    autoplay={{
                                        delay: 1,
                                        disableOnInteraction: false,
                                        waitForTransition: true,
                                        pauseOnMouseEnter: true,
                                        reverseDirection: true,
                                    }}
                                    loop={true}
                                    className="swiper-container"
                                    onSlideChange={(e) => {}}
                                    onSwiper={(swiper) => {}}
                                    autoHeight={true}
                                    height={400}
                                >
                                    {REVIEWS2?.map((review, index) => (
                                        <SwiperSlide
                                            key={review.id}
                                            className={`swiper-slide ${
                                                review.showImage
                                                    ? "with-image-h"
                                                    : "without-image-h"
                                            }`}
                                            style={{
                                                height: "100% !important",
                                                color: "red",
                                            }}
                                        >
                                            {review.showImage ? (
                                                <div className="with-image h-full">
                                                    {review.videoId ? (
                                                        <div
                                                            className="picture object-fill h-full"
                                                            onClick={() =>
                                                                openModal(
                                                                    index,
                                                                    2
                                                                )
                                                            }
                                                            style={{
                                                                cursor: "pointer",
                                                            }}
                                                        >
                                                            <Image
                                                                loading="lazy"
                                                                src={
                                                                    review.thumbnail
                                                                }
                                                                alt="Picture"
                                                                className="picture object-fill h-full"
                                                            />
                                                            <div
                                                                className="play-button"
                                                                style={{
                                                                    position:
                                                                        "absolute",
                                                                    top: "50%",
                                                                    left: "50%",
                                                                    transform:
                                                                        "translate(-50%, -50%)",
                                                                    cursor: "pointer",
                                                                }}
                                                            >
                                                                <svg
                                                                    width="61"
                                                                    height="61"
                                                                    viewBox="0 0 61 61"
                                                                    fill="none"
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                >
                                                                    <circle
                                                                        cx="30.5"
                                                                        cy="30.5"
                                                                        r="30.5"
                                                                        fill="#FFF3ED"
                                                                    />
                                                                    <path
                                                                        d="M42 30L24 40.3923L24 19.6077L42 30Z"
                                                                        fill="#FF4514"
                                                                    />
                                                                </svg>
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <Image
                                                            loading="lazy"
                                                            src={review.image}
                                                            alt="Picture"
                                                            className="picture object-fill h-full"
                                                        />
                                                    )}

                                                    <VideoModal
                                                        videoTitle={
                                                            review.videoTitle
                                                        }
                                                        videoId={review.videoId}
                                                        isOpen={
                                                            modal2States[index]
                                                        }
                                                        onClose={() => {
                                                            closeModal(
                                                                index,
                                                                2
                                                            );
                                                            swiperRef1.current.swiper.autoplay.start();
                                                            swiperRef2.current.swiper.autoplay.start();
                                                        }}
                                                    />
                                                </div>
                                            ) : (
                                                <div className="without-image p-4 xl:p-6 flex flex-col gap-3 h-full">
                                                    <p className="lead">
                                                        {review.review}
                                                    </p>
                                                    <div className="avatar flex items-center mt-auto gap-3">
                                                        <Image
                                                            loading="lazy"
                                                            src={review.image}
                                                            alt="Avatar"
                                                            className="avatar"
                                                        />
                                                        <span className="font-semibold">
                                                            {review.name}
                                                        </span>
                                                    </div>
                                                </div>
                                            )}
                                        </SwiperSlide>
                                    ))}
                                </Swiper>
                            </div>
                        </div>
                    </div>
                    <div className="happy-customers-slider happy-customers-slider-horizontal col-span-1 flex flex-col gap-4 lg:col-span-1 mt-4 h-32">
                        <Swiper
                            slidesPerView={1.5}
                            spaceBetween={30}
                            centeredSlides={true}
                            direction="horizontal"
                            speed={3000}
                            modules={[Autoplay]}
                            autoplay={{
                                delay: 1,
                                disableOnInteraction: false,
                                waitForTransition: true,
                                pauseOnMouseEnter: true,
                            }}
                            loop={true}
                            className="swiper-container"
                            autoHeight={false}
                            height={100}
                        >
                            {REVIEWS1?.map((review, index) => (
                                <SwiperSlide
                                    key={review.id}
                                    className={`swiper-slide ${
                                        review.showImage
                                            ? "with-image-h"
                                            : "without-image-h"
                                    }`}
                                    style={{
                                        height: "100% !important",
                                        color: "red",
                                    }}
                                >
                                    {review.showImage ? (
                                        <div className="with-image h-full">
                                            {review.videoId ? (
                                                <div
                                                    className="picture object-fill h-full"
                                                    onClick={() =>
                                                        openModal(index, 1)
                                                    }
                                                    style={{
                                                        cursor: "pointer",
                                                    }}
                                                >
                                                    <Image
                                                        loading="lazy"
                                                        src={review.thumbnail}
                                                        alt="Picture"
                                                        className="picture object-fill h-full"
                                                    />
                                                    <div
                                                        className="play-button"
                                                        style={{
                                                            position:
                                                                "absolute",
                                                            top: "50%",
                                                            left: "50%",
                                                            transform:
                                                                "translate(-50%, -50%)",
                                                            cursor: "pointer",
                                                        }}
                                                    >
                                                        <svg
                                                            width="61"
                                                            height="61"
                                                            viewBox="0 0 61 61"
                                                            fill="none"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                            <circle
                                                                cx="30.5"
                                                                cy="30.5"
                                                                r="30.5"
                                                                fill="#FFF3ED"
                                                            />
                                                            <path
                                                                d="M42 30L24 40.3923L24 19.6077L42 30Z"
                                                                fill="#FF4514"
                                                            />
                                                        </svg>
                                                    </div>
                                                </div>
                                            ) : (
                                                <Image
                                                    loading="lazy"
                                                    src={review.image}
                                                    alt="Picture"
                                                    className="picture object-fill h-full"
                                                />
                                            )}
                                        </div>
                                    ) : (
                                        <div className="without-image p-4 xl:p-6 flex flex-col gap-3 h-full">
                                            <p className="lead">
                                                {review.review}
                                            </p>
                                            <div className="avatar flex items-center mt-auto gap-3">
                                                <Image
                                                    loading="lazy"
                                                    src={review.image}
                                                    alt="Avatar"
                                                    className="avatar"
                                                />
                                                <span className="font-semibold">
                                                    {review.name}
                                                </span>
                                            </div>
                                        </div>
                                    )}
                                </SwiperSlide>
                            ))}
                            {REVIEWS2?.map((review, index) => (
                                <SwiperSlide
                                    key={review.id}
                                    className={`swiper-slide ${
                                        review.showImage
                                            ? "with-image-h"
                                            : "without-image-h"
                                    }`}
                                    style={{
                                        height: "100% !important",
                                        color: "red",
                                    }}
                                >
                                    {review.showImage ? (
                                        <div className="with-image h-full">
                                            {review.videoId ? (
                                                <div
                                                    className="picture object-fill h-full"
                                                    onClick={() =>
                                                        openModal(index, 2)
                                                    }
                                                    style={{
                                                        cursor: "pointer",
                                                    }}
                                                >
                                                    <Image
                                                        loading="lazy"
                                                        src={review.thumbnail}
                                                        alt="Picture"
                                                        className="picture object-fill h-full"
                                                    />
                                                    <div
                                                        className="play-button"
                                                        style={{
                                                            position:
                                                                "absolute",
                                                            top: "50%",
                                                            left: "50%",
                                                            transform:
                                                                "translate(-50%, -50%)",
                                                            cursor: "pointer",
                                                        }}
                                                    >
                                                        <svg
                                                            width="61"
                                                            height="61"
                                                            viewBox="0 0 61 61"
                                                            fill="none"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                            <circle
                                                                cx="30.5"
                                                                cy="30.5"
                                                                r="30.5"
                                                                fill="#FFF3ED"
                                                            />
                                                            <path
                                                                d="M42 30L24 40.3923L24 19.6077L42 30Z"
                                                                fill="#FF4514"
                                                            />
                                                        </svg>
                                                    </div>
                                                </div>
                                            ) : (
                                                <Image
                                                    loading="lazy"
                                                    src={review.image}
                                                    alt="Picture"
                                                    className="picture object-fill h-full"
                                                />
                                            )}
                                        </div>
                                    ) : (
                                        <div className="without-image p-4 xl:p-6 flex flex-col gap-3 h-full">
                                            <p className="lead">
                                                {review.review}
                                            </p>
                                            <div className="avatar flex items-center mt-auto gap-3">
                                                <Image
                                                    loading="lazy"
                                                    src={review.image}
                                                    alt="Avatar"
                                                    className="avatar"
                                                />
                                                <span className="font-semibold">
                                                    {review.name}
                                                </span>
                                            </div>
                                        </div>
                                    )}
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HappyCustomers;
